// extracted by mini-css-extract-plugin
export default {"page":"LicenseAgreementPage_page__s2ysw","container":"LicenseAgreementPage_container__ltuaI"};